<template>
    <templateBase
        module-name="Empreendimentos"
        :load="loadeInit && loadeInitFilters"
        :load-product="loadProduct"
        :description="`${totalProducts} empreendimentos ${searchOrfilter}`"
        :exists-products="existsProducts"
        title="Lista"
        @new-content="newContent"
    >
        <template #sidebar-right>
            <filters :data="filters" @filter="filter($event)"/>
        </template>
		
        <template #page >
            <section v-if="!loadProduct" class="products-list" >
                <div v-for="data in products" :key="data.id">
                    <ui-product-card
                        :data="data"
                        :footer-button="footerButton"
                        :footer-button-action="toHotsite"
                        :integration-api-uau="integrationApiUau"
						:integrations="integrations"
                    />
                </div>
            </section>

            <section v-if="loader" class="load-page">
                <ui-load-indicator :h="60" :stroke="8"  bg-color="#DFE5EC" color="#4BB1FF" />
            </section>
        </template>
    </templateBase>
</template>

<script>
	import { uiLoadIndicator } from '@/components/ui'
	import { uiProductCard } from "@/components/ui-facilita/products"
	import { configuration, erp, product } from '@/services/axios'
	import { storage } from '@/services/storage'
	import { mapGetters } from 'vuex'

	import helpers from '@/mixins/helpers'
	import templateBase from "@/templates/page-products"
	import filters from './filters'

	export default {
		name:"list-product",
		components: {
			templateBase,
			uiProductCard,
			filters,
			uiLoadIndicator
		},
		mixins: [ helpers ],
		data(){
			return {
				pageInfos: {},
				loadProduct: false,
				loadeInit: true,
				loadeInitFilters: true,
				loader: false,
				existsProducts: false,
				totalProducts: 0,
				products: [],
				productsFiltredsItems: null,
				searchProducts: [],
				filters: null,
				integrationApiUau: null,
				last_page: null,
				page: 1,
				searchOrfilter: 'cadastrado',
				filterItems: {},
				construct: true,
				nameValue: null,
				request: false,
				card: {
					hotsite: false
				},
				integrations: []
			}
		},

		computed: {
			...mapGetters('auth', {
				user: 'getUser',
			}),
			footerButton() {
				return this.card.hotsite ? 'Hotsite' : ''
			}
		},

		created() {
			//buscar produtos
			this.$root.$on('set-search-enterprise', value => {
				this.$root.$emit('scroll-to-top')
				this.reset()
				this.loadProduct 	= true
				this.loader 		= false
				this.nameValue 		= value
				this.setProducts({per_page: 20, page: 1, items: this.productsFiltredsItems}, 'start')
			})
			//aqui tras uma nova remessa de produtos quando chega no final da página, caso exista!
    	},

		beforeDestroy() {
			this.$root.$off('set-search-enterprise')
		},

		mounted() {
			//verifica se existe informações de filtro salva no local-storage
			let productsFiltreds = JSON.parse(storage.get('product_filter'))
			let itemChecked = []
			let item = []
			configuration.getConfigurations().then((value) => {
				value.data.map(res => {
					if(res.name == 'integrationApiUau') {
						this.integrationApiUau = res
					}

					if(res.name == "allowedApps"){
						const hotsite = res.value_long.find(app => app == 'hotsite')
						this.card.hotsite = hotsite ? true : false
					}
				})
			})
			this.productsFiltredsItems = productsFiltreds && Object.keys(productsFiltreds).length > 0 ? Object.keys(productsFiltreds).join() : null
			//faz um filtro no local-storage para deixar o checkbox salvo ativo.
			product.get('filters', '').then(res => {
				item = []
				if (productsFiltreds) {
					item.push(Object.keys(productsFiltreds))
					res.data.forEach(result => {
						result.items.map(response => {
							item[0].map(element => {
								if (response.id == element) {
									response.checked = true
								}
							})
						})
					})
				}
				this.loadeInitFilters = false
           		this.filters = res.data
        	})
			//se retornar algum dados faz o filtro sempre que der um reload na pagina
			if (productsFiltreds) {
				item = []
				item.push(Object.keys(productsFiltreds))
				item[0].map(res => {
					typeof res == 'string' ? itemChecked.push(JSON.parse(res)) : itemChecked.push(res)
				})
				this.filter(itemChecked)
			} else {
				this.setProducts({per_page: 20, page: 1, items: null}, 'start')
			}
			this.getIntegrationInformakon()
		},
		methods: {
			//filter filtrar os dados e busca no banco ao fazer a seleção no checkbox
			 filter(value){
				this.productsFiltredsItems = value ? value.toString() : null
				this.loadProduct = true
				 if (value) {
					this.filterItems = {items: value.toString(), page: 1, per_page: 20}
					let storageFilterProduct = {}
					if (value.length > 0) {
						value.forEach(res => {
							storageFilterProduct[(JSON.stringify(res))] = true
						})
						storage.set('product_filter', JSON.stringify(storageFilterProduct))

						this.setProducts(this.filterItems, 'filter')
					}
				 }
				 else {
					this.page = 1
					this.setProducts({per_page: 20, page: this.page, items: null}, 'start')
				 }
			},
			async setProducts(val, search) {
				if (this.nameValue) val.name = this.removeCharMask(this.nameValue)
				if (this.request) return
				this.request = true
				await product.searchProductFiltred(val).then(res => {
					this.request = false
					switch (search) {
						case 'start':
							this.page = 2
							this.start(res)
							break
						case 'plus-product':
							this.plusProduct(res)
							break
						case 'filter':
							this.page = 2
							this.setFilter(res)
							break
					}
				})
			},
			reset() {
				this.construct	 	= true
				this.last_page 		= null
				this.page 			= 1
				this.totalProducts 	= 0
				this.searchProducts	= []
			},
			//recebe os primeiros produtos
			start(res) {
				//tras os primeiros produtos
				this.searchOrfilter	= res.data.data.length > 1 ? 'cadastrados' : 'cadastrado'
				this.products 		= []
				this.products 		= res.data.data
				this.totalProducts 	= res.data.total
				this.last_page 		= res.data.last_page
				this.loadProduct 	= false
				this.loader 		= this.products && this.totalProducts > 20 ? true : false
				this.loadeInit 		= false
				this.existsProducts = this.products.length > 0 ? false : true
			},

			//adiciona mais produtos pelo scroll
			plusProduct (res) {
				if(res.data.data.length > 0 && this.products.length < res.data.total) {
					res.data.data.forEach( result => {
						if (this.products.length <= this.totalProducts) {
							this.products.push(result)
						}
					})
					if (this.products.length > this.totalProducts) {
						this.products = this.products.pop()
					}
					if (this.products.length == this.totalProducts) {
						this.loader = false
					}
					this.page++
					this.construct = true
				}
			},
			setFilter(res) {
				this.searchOrfilter	= res.data.data.length > 1 ? 'filtrados' : 'filtrado'
				this.products 		= res.data.data
				this.totalProducts 	= res.data.total
				this.last_page 		= res.data.last_page
				this.loader 		= this.products && this.totalProducts > 20 ? true : false
				this.loadeInit 		= false
				this.existsProducts = this.products.length > 0 ? false : true
				this.loadProduct 	= false
			},
			newContent() {
				if(this.products.length <= this.totalProducts && this.last_page > 1 && this.page <= this.last_page && this.construct) {
					this.construct = false
					return this.setProducts({per_page: 20, page: this.page, items: this.productsFiltredsItems}, 'plus-product')
				}
			},
			async toHotsite(productId){
				if(!productId) return
				const instance 	= await this.getInstance() // helper
				const userId 	= this.user.id
				const url 		= `https://hotsite.meucorretor.digital/${instance}/${userId}/${productId}`
				window.open(url, '_blank')
			},
			async getIntegrationInformakon() {
				try {
					const response = await erp.getIntegrations();
					this.integrations = Object.values(response.data.data)
						.filter(integration => integration.type === 'informakon' && integration.deleted_at === null)
				} catch (error) {
					console.error(error)
				}
        	}
		}
	}
</script>

<style lang="stylus" scoped>
	@import '~@/assets/styl/base.styl'
	.products-list
		display flex
		flex-wrap wrap
		justify-content flex-start
		margin-left -12px
		margin-right -12px
		div
			padding 0 10px 20px 10px
	.load-page
		padding-top 20px
		display flex
		justify-content center
	.load-page-product
		position: absolute
		z-index: 10000
		margin: 0 !important
		height: 100%
		background: #fff
		width: 100%
		display flex
		justify-content center
		align-items center
</style>
